import React from 'react'
import type { HTMLElementProps } from '~/types'

type Props = HTMLElementProps<'svg'>

export const Caret: React.FC<Props> = ({ stroke = 'currentColor', ...props }) => (
	<svg viewBox="0 0 7 5" fill="none" height="0.42em" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M0.5 1L3.5 4L6.5 1" stroke={stroke} />
	</svg>
)
